import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDatepickerMaskDirective } from '@anihis/shared/src/shared/directive/mat-datepicker-mask.directive';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslocoModule } from '@jsverse/transloco';
import { appInit } from '@anihis/shared/src/functions/appInitLang';
import {
  getMaxBirthDate,
  getMinAnimalBirthDate,
} from '@anihis/shared/src/validators/birth-date.validators';

@Component({
  selector: 'anihis-durogesic-patch-instructions',
  templateUrl: './durogesic-patch-instructions.component.html',
  styleUrls: ['./durogesic-patch-instructions.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatDatepickerMaskDirective,
    MatNativeDateModule,
    TranslocoModule,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useFactory: appInit }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DurogesicPatchInstructionsComponent {
  minDate = getMinAnimalBirthDate();
  today = getMaxBirthDate();

  @Output() formChange = new EventEmitter<any>();

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      removePatch: new FormControl(null),
      veterinarianName: new FormControl(''),
    });

    this.form.valueChanges.subscribe((value) => this.formChange.emit(value));
  }

  get removePatch(): FormControl {
    return this.form.get('removePatch') as FormControl;
  }

  get veterinarianName(): FormControl {
    return this.form.get('veterinarianName') as FormControl;
  }

  clearForm() {
    this.form.reset();
  }
}
